export default __webpack_public_path__ + "static/media/Pilgrim's Girdle of the Soaring Heart.0cd67e8b.jpg";